module.exports = __webpack_public_path__ + "img/ZW.bdb8b2bf.png";